export default __webpack_public_path__ + "static/media/menuBurger.294a0697.svg";